import { defineComponent as _defineComponent } from 'vue'
import {computed} from 'vue';
import Button from './Button.vue';

/**
 * component: ButtonPrimary
 *
 * variation of Button for primary action
 */

interface IProps {
	inverted?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonPrimary',
  props: {
    inverted: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { inverted: boolean };



const color = computed((): string => {
	return props.inverted ? 'white' : 'action-primary';
});

const textColor = computed((): string => {
	return props.inverted ? 'action-primary' : 'white';
});


return { __sfc: true,props, color, textColor, Button }
}

})